import React from "react";

const Footer = () => {
  return (
    <div className="border-t border-gray-500 mt-20">
      <h1 className="font-semibold text-sm mt-6 mb-10">
        &copy;{new Date().getFullYear()} AlnickDev.
      </h1>
    </div>
  );
};

export default Footer;
